module.exports = __webpack_public_path__ + "img/immo-acceuil-savoir-faire.c7ccd501.png";